'use client'
import {
  context_default
} from "./chunk-XG65SW5G.mjs";

// src/context/provider.tsx
import { useCallback, useEffect, useMemo, useState } from "react";
import { useRouter } from "@wbk/config";
import { createCookie } from "@wbk/utils";
import { getQueueSessionCookieName } from "@wbk/api";
import { useGetSeason, useGetTicketingEvent, useGetTicketingPackage } from "@wbk/api/hooks";
import { jsx } from "react/jsx-runtime";
var QueueProvider = ({ children }) => {
  var _a;
  const { params, locale } = useRouter();
  const [target, setTarget] = useState(null);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const slug = (params == null ? void 0 : params.queuedSlug) || "";
  const activeTarget = (target == null ? void 0 : target.slug) === slug ? target : null;
  const activeType = activeTarget == null ? void 0 : activeTarget.type;
  const refetchInterval = autoRefresh ? 6e4 : false;
  const { data: seasonData } = useGetSeason(
    { slug, lang: locale },
    { enabled: !!slug && activeType === "season", refetchInterval }
  );
  const { data: eventData } = useGetTicketingEvent(
    { slug, lang: locale },
    { enabled: !!slug && activeType === "event", refetchInterval }
  );
  const { data: packageData } = useGetTicketingPackage(
    { slug, lang: locale },
    { enabled: !!slug && activeType === "bundle", refetchInterval }
  );
  const activeData = (() => {
    switch (activeType) {
      case "season":
        return seasonData;
      case "event":
        return eventData;
      case "bundle":
        return packageData;
      default:
        return void 0;
    }
  })();
  const queue = activeData == null ? void 0 : activeData._queue;
  const isActive = !!(queue == null ? void 0 : queue.queued);
  const canJumpQueue = !!(activeData && "subscription_benefits" in activeData && ((_a = activeData.subscription_benefits) == null ? void 0 : _a.queue_jump_online));
  const initQueue = useCallback(
    (type = "event", bypass = false) => {
      setTarget(bypass || !slug ? null : { type, slug });
    },
    [slug]
  );
  useEffect(() => {
    setAutoRefresh(false);
  }, [slug, activeType]);
  useEffect(() => {
    if (!(activeData == null ? void 0 : activeData.sessionId)) return;
    createCookie({
      name: getQueueSessionCookieName(slug),
      value: activeData.sessionId
    });
  }, [activeData == null ? void 0 : activeData.sessionId, slug]);
  const value = useMemo(
    () => ({
      autoRefresh,
      isActive,
      slug,
      canJumpQueue,
      queue,
      initQueue,
      setAutoRefresh
    }),
    [autoRefresh, isActive, slug, canJumpQueue, queue, initQueue]
  );
  return /* @__PURE__ */ jsx(context_default.Provider, { value, children });
};
var provider_default = QueueProvider;

export {
  provider_default
};
//# sourceMappingURL=chunk-67EB5H3Y.mjs.map